export default __webpack_public_path__ + "static/media/Minicard_8s.118f20d2.svg";